import { post } from "./HttpClient"
import {  API_REGISTER } from "./ApisRoutes"

export const RegisterService = (params) => {
    return new Promise((resolve, reject) => {
        post(API_REGISTER, params).then(response => {
            const _registerResponse = response?.data;
            resolve(_registerResponse);
        }).catch(error => {
            console.log(error, "Register response error");
            reject(error);
        });
    });
}
